"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketSubmissionPrizeDTOList = void 0;
const TicketSubmissionPrizeDTO_1 = require("./TicketSubmissionPrizeDTO");
const types_1 = require("./types");
class TicketSubmissionPrizeDTOList extends Array {
    constructor() {
        super(...arguments);
        this.getPrizeTitle = () => 'Ticket Validated';
        this.getPrizeMessage = (isScannedEntry) => {
            let message = '';
            if (this.length > 0) {
                const entries = this.filter((x) => x.prizeType === types_1.PrizeType.ENTRY);
                const points = this.filter((x) => x.prizeType === types_1.PrizeType.LOYALTY_POINTS);
                if (entries.length === 1 && points.length === 1) {
                    message = `You've earned ${points[0].amount} Points and have been entered into a Second Chance Draw!`;
                }
                else if (entries.length === 1) {
                    message = `${isScannedEntry ? 'Scanning' : 'Adding'} this ticket has successfully entered you into a Second Chance Draw`;
                }
                else if (points.length === 1) {
                    message = `Ticket successfully ${isScannedEntry ? 'scanned. Scan' : 'entered. Enter'} another, or go back if done.`;
                }
            }
            return message;
        };
        this.getPoints = (isDigitalReveal) => {
            if (this.length > 0) {
                const points = this.filter((x) => {
                    return !!isDigitalReveal
                        ? x.prizeType === types_1.PrizeType.LOYALTY_POINTS && !!x.token && !x.preassigned
                        : x.prizeType === types_1.PrizeType.LOYALTY_POINTS && !x.token && !x.preassigned;
                });
                if (points.length >= 1) {
                    return points[0].amount ? points[0].amount : 0;
                }
            }
            return -1;
        };
        this.getEntries = (isDigitalReveal) => {
            let entries = new TicketSubmissionPrizeDTOList();
            if (this.length > 0) {
                const entriesArray = this.filter((x) => {
                    var _a;
                    const digitalRevealCondition = !!x.token || !!((_a = JSON.parse(x.extraData)) === null || _a === void 0 ? void 0 : _a.hasDigitalReveal);
                    return x.prizeType === types_1.PrizeType.ENTRY && (!!isDigitalReveal ? digitalRevealCondition : !digitalRevealCondition);
                });
                entries = TicketSubmissionPrizeDTOList.TicketSubmissionPrizeDTOArrayToTicketSubmissionPrizeDTOList(entriesArray);
            }
            return entries;
        };
        this.hasWinningTicket = () => (this.length <= 0 ? false : !!this.find((x) => !!x.hasWinningTicket));
    }
}
exports.TicketSubmissionPrizeDTOList = TicketSubmissionPrizeDTOList;
TicketSubmissionPrizeDTOList.JsonToTicketSubmissionPrizeDTOList = (data) => {
    const ticketSubmissionPrizeDTOList = new TicketSubmissionPrizeDTOList();
    data.forEach(ticketSubmissionPrizeDTO => ticketSubmissionPrizeDTOList.push(TicketSubmissionPrizeDTO_1.TicketSubmissionPrizeDTO.JsonToTicketSubmissionPrizeDTO(ticketSubmissionPrizeDTO)));
    return ticketSubmissionPrizeDTOList;
};
TicketSubmissionPrizeDTOList.TicketSubmissionPrizeDTOArrayToTicketSubmissionPrizeDTOList = (data) => {
    const ticketSubmissionPrizeDTOList = new TicketSubmissionPrizeDTOList();
    data.forEach(ticketSubmissionPrizeDTO => ticketSubmissionPrizeDTOList.push(ticketSubmissionPrizeDTO));
    return ticketSubmissionPrizeDTOList;
};
//# sourceMappingURL=TicketSubmissionPrizeDTOList.js.map